// 合并同一帧内通知，并遵守 disconnect/unobserve 的生命周期，避免回调已销毁组件。
export function createDebouncedResizeObserver(NativeResizeObserver) {
  return class DebouncedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      const targets = new Set(), pending = new Map();
      let timer = null;
      const cancel = () => { clearTimeout(timer); timer = null; };
      super((entries, observer) => {
        for (const entry of entries) if (targets.has(entry.target)) pending.set(entry.target, entry);
        cancel();
        if (!pending.size) return;
        timer = setTimeout(() => {
          timer = null;
          const batch = [...pending.values()].filter(entry => targets.has(entry.target));
          pending.clear();
          if (batch.length) callback(batch, observer);
        }, 16);
      });
      this.cancelPendingResize = cancel;
      this.resizeTargets = targets;
      this.pendingResizes = pending;
    }
    observe(target, options) {
      super.observe(target, options);
      this.resizeTargets.add(target);
    }
    unobserve(target) {
      this.resizeTargets.delete(target);
      this.pendingResizes.delete(target);
      if (!this.pendingResizes.size) this.cancelPendingResize();
      super.unobserve(target);
    }
    disconnect() {
      this.cancelPendingResize();
      this.pendingResizes.clear();
      this.resizeTargets.clear();
      super.disconnect();
    }
  };
}
